export default __webpack_public_path__ + "static/presse-huettn-1-download-c6cf6ac7324cb8496ade112c78c37ed9.jpg";